require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#5A189A',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        tertiary: '#EE87A6',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
      dark: {
        primary: '#5A189A',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        tertiary: '#EE87A6',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
    },
  },
}
